import { useCallback, useState } from "react";
import type { Selection } from "@/types/device-manager.types";

// Estado de seleção + expansão da árvore CLP → Cartão → Sensor (espelha clp-app.jsx).
export function useTreeSelection() {
  const [sel, setSel] = useState<Selection>(null);
  const [expanded, setExpanded] = useState<Set<string>>(new Set());
  const [query, setQuery] = useState("");

  const toggle = useCallback((id: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const expand = useCallback((id: string) => {
    setExpanded((prev) => new Set(prev).add(id));
  }, []);

  const select = useCallback((next: Selection) => setSel(next), []);

  return { sel, expanded, query, setQuery, toggle, expand, select } as const;
}
